import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TUsedInList = components['schemas']['UsedInListResDto'];
export type TUsedInRow = TUsedInList['data'][number];
export type TUsedInKind = 'source' | 'destination' | 'transform';

export const listUsedIn = (kind: TUsedInKind, id: string): Promise<TUsedInList> => {
  const params = { params: { path: { id } } };
  if (kind === 'source') return unwrap(api.GET('/v1/flows/used-in/sources/{id}', params));
  if (kind === 'destination') return unwrap(api.GET('/v1/flows/used-in/destinations/{id}', params));
  return unwrap(api.GET('/v1/flows/used-in/transforms/{id}', params));
};

export const usedInKeys = {
  one: (kind: TUsedInKind, id: string) => ['used-in', kind, id] as const,
  transforms: ['used-in', 'transform', 'all'] as const,
  targets: (sourceId: string) => ['used-in', 'source', sourceId, 'targets'] as const,
  steps: (q: string) => ['used-in', 'steps', q] as const,
  destinationCounts: ['used-in', 'destination', 'counts'] as const,
};

export type TTransformUsedIn = components['schemas']['TransformUsedInResDto'];
export type TTransformUse = TTransformUsedIn['flows'][number];

export const listTransformsUsedIn = (): Promise<TTransformUsedIn[]> =>
  unwrap(api.GET('/v1/flows/used-in/transforms')).then((list) => list.data);

export type TSourceTarget = components['schemas']['TestSendTargetResDto'];

export const listSourceTargets = (sourceId: string): Promise<TSourceTarget[]> =>
  unwrap(
    api.GET('/v1/flows/used-in/sources/{id}/targets', { params: { path: { id: sourceId } } }),
  ).then((list) => list.data);

export type TStepHit = components['schemas']['FlowStepHitResDto'];

export const searchSteps = (q: string): Promise<TStepHit[]> =>
  unwrap(api.GET('/v1/flows/used-in/steps', { params: { query: { q } } })).then(
    (list) => list.data,
  );

export type TDestinationFlowCount = components['schemas']['DestinationFlowCountResDto'];

// The Destinations list's Flows column: one request for the page, not one per row.
export const destinationFlowCounts = (): Promise<Map<string, number>> =>
  unwrap(api.GET('/v1/flows/used-in/destinations')).then(
    (list) => new Map(list.data.map((row) => [row.destinationId, row.flows])),
  );
